import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { AvailabilityDataType } from '../../../../models/dashboard/settings/profileSettings/availability.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../../models/https';
import useHttps from '../../../useHttps';
import useGetUserData from '../useGetUserData';

const useUpdateAvailabilityStatus = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const { getUserData } = useGetUserData();

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while updating availability status'
    );
  };

  const onSuccess = ({ message }: SuccessHttpResponse<any>) => {
    toast.success(message);
    getUserData();
  };

  const updateAvailability = (data: AvailabilityDataType) => {
    const formData = new FormData();
    formData.append('isAvailableForWork', String(data.isAvailableForWork));

    const url: HttpConfig = {
      url: `auth-service/users`,
      method: 'patch',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    request(url, onSuccess, setLoading, onError);
  };

  return { updateAvailability, loading };
};

export default useUpdateAvailabilityStatus;
